import React, { useState } from 'react';
import SharedHeader from '../../components/shared/SharedHeader';
import ProtectedPage from '../../components/shared/ProtectedPage';
import { usePermissions } from '../../utils/usePermissions';
import UsersSubTab from './components/UsersSubTab';
import UserRolesSubTab from './components/UserRolesSubTab';
import UserLogsSubTab from './components/UserLogsSubTab';
import './Settings.css';

function Settings({ activeSubTab = 'users', onNavigate }) {
  const [searchQuery, setSearchQuery] = useState('');

  const activeTab = activeSubTab === 'roles' ? 'roles' : activeSubTab === 'logs' ? 'logs' : 'users';

  const tabs = [
    { id: 'users', label: 'Users' },
    { id: 'roles', label: 'User Roles' },
    { id: 'logs', label: 'User Logs' }
  ];

  return (
    <ProtectedPage module="settings">
      <div className="settings-page-wrapper">
        {/* Shared Header Controls */}
        <SharedHeader
          title="Settings"
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          searchPlaceholder="Search users, roles, or system logs..."
          showSortFilter={false}
      />

      {/* Sub-tabs Selectors (Identical UI to E-Accounts screenshot) */}
      <div className="eaccounts-tabs-row">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`eaccounts-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => {
              if (onNavigate) {
                onNavigate(`/settings/${tab.id}`);
              }
              setSearchQuery('');
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Render Active Sub-tab View */}
      <div style={{ marginTop: '20px' }}>
        {activeTab === 'roles' ? (
          <UserRolesSubTab searchQuery={searchQuery} />
        ) : activeTab === 'logs' ? (
          <UserLogsSubTab searchQuery={searchQuery} />
        ) : (
          <UsersSubTab searchQuery={searchQuery} />
        )}
        </div>
      </div>
    </ProtectedPage>
  );
}

export default Settings;
